import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {VirtualReceipt} from "../model/virtualReceipt";
import {VirtualReceipts} from "../model/virtualReceipts";

@Injectable({ providedIn: 'root' })
export class VirtualReceiptService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAllPaged(offset: number, limit: number, filters?: any[], sort?: any[]) {
        let filtersStr = '';


        if (sort && sort['sortDir'] && sort['sortCol']) {
            filtersStr += '&sortDir=' + sort['sortDir'] + '&sortCol=' + sort['sortCol'];
        }

        return this.http.get<VirtualReceipts>(`${environment.apiEndpoint}/v1/virtual-receipts?offset=` + offset + '&limit=' + limit + filtersStr, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<VirtualReceipt>(`${environment.apiEndpoint}/v1/virtual-receipts/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getByCustomer(id: string) {
        return this.http.get<VirtualReceipt>(`${environment.apiEndpoint}/v1/virtual-receipts/${id}/by-customer`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/virtual-receipts/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: VirtualReceipt) => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/virtual-receipts`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: VirtualReceipt) => {
                return x;
            }));
    }
}
